/**
 * Frontend client for report subscriptions (#183) — automated delivery of a
 * saved report on a cadence (and, in Phase 2, on test completion).
 */

import { apiRequest } from './api';
import type {
  ReportSubscription,
  ReportSubscriptionInput,
} from '@simcheck/shared-types';

export async function listReportSubscriptions(
  organizationId: string,
): Promise<ReportSubscription[]> {
  const r = await apiRequest<{ subscriptions: ReportSubscription[]; count: number }>(
    '/reports/subscriptions',
    { method: 'GET' },
    organizationId,
  );
  return r.subscriptions;
}

export async function createReportSubscription(
  organizationId: string,
  input: ReportSubscriptionInput,
): Promise<ReportSubscription> {
  return apiRequest<ReportSubscription>(
    '/reports/subscriptions',
    { method: 'POST', body: JSON.stringify(input) },
    organizationId,
  );
}

export async function updateReportSubscription(
  organizationId: string,
  id: string,
  patch: Partial<ReportSubscriptionInput>,
): Promise<ReportSubscription> {
  return apiRequest<ReportSubscription>(
    `/reports/subscriptions/${id}`,
    { method: 'PATCH', body: JSON.stringify(patch) },
    organizationId,
  );
}

export async function deleteReportSubscription(
  organizationId: string,
  id: string,
): Promise<void> {
  await apiRequest<{ ok: true }>(
    `/reports/subscriptions/${id}`,
    { method: 'DELETE' },
    organizationId,
  );
}

export async function testSendReportSubscription(
  organizationId: string,
  id: string,
): Promise<{ status: string; sentTo?: string[] }> {
  return apiRequest<{ status: string; sentTo?: string[] }>(
    `/reports/subscriptions/${id}/test-send`,
    { method: 'POST' },
    organizationId,
  );
}
